import Vue from 'vue'
import PrintDialog from './print-dialog.vue'

PrintDialog.install = function (Vue) {
	Vue.component(PrintDialog.name, PrintDialog);
}

export default PrintDialog


class PrintDialogInstance {
    constructor() {
        this.instance = null;
    }
    init() {
        const VueInstance = Vue || window.Vue;
        let printDialogComponent = VueInstance.extend(PrintDialog);
        this.instance = new printDialogComponent({
            el: document.createElement('div'),
        }).$mount();
        document.body.appendChild(this.instance.$el);
    }
    getInstance() {
        return this.instance;
    }
    show(options) {
        return new Promise((resolve, reject) => {
            if (!this.instance) {
                this.init();
            }
            Object.assign(this.instance, {resolve, reject})
            this.instance.show(options);
        })
    }
}

export const printDialog = new PrintDialogInstance();
window.printDialog = printDialog;
